<style scoped>
	#sector {
		width: 100%;
		height: 25rem;
		margin: 0 auto;
	}

	#sxpice {
		width: 100%;
		height: 20rem;
		margin: 0 auto;
	}

	#sxpople {
		width: 100%;
		height: 20rem;
		margin: 1rem auto;
	}
</style>
<template>
	<div style="width: 100%;">
		<div id="sector" v-if="datetypes=='linear'">
		</div>
		<div id="sxpice" v-if="datetypes=='pie'">

		</div>
		<div id="sxpople" v-if="datetypes=='pie1'">

		</div>
	</div>
</template>

<script>
	// import echarts from 'echarts'
	// import * as echarts from 'echarts'

	// const echarts = require('echarts');
	export default {
		props: {
			type: [String, Number],
			datetype: String,
			// 数据对象
			trainchats: Object
		},
		name1: 'sector',
		name2: "sxpice",
		data() {
			return {
				trainchat: this.trainchats,
				datetypes: this.datetype,
				option: {
					color: [{
						type: this.datetypes,
						x: 1,
						y: 0,
						x2: 1,
						y2: 1,
						colorStops: [{
								offset: 0,
								color: '#336BB5'
							}, // 设置颜色渐变
							{
								offset: 1,
								color: '#49968D'
							},

						]
					}],
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', "8月", "9月", "10月", "11月", "12月"],
						axisTick: {
							alignWithLabel: true
						}
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
						name: 'Direct',
						type: 'bar',
						barWidth: '60%',
						data: [500, 700, 820, 900, 920, 1390, 900, 700, 800, 600, 400, 500]
					}]
				},

				option1: {
					legend: {
						bottom: '0%',
					},
					tooltip: {
						trigger: 'item'
					},
					series: [{
						name: '实时设备状态统计',
						type: "pie",
						radius: ['40%', '70%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '18',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: [{
								value: 742,
								name: '空闲中',
								itemStyle: {
									color: "#5470C6"
								},
							},
							{
								value: 2721,
								name: '使用中',
								itemStyle: {
									color: "#91CC75"
								},
							},
							{
								value: 1000,
								name: '离线中',
								itemStyle: {
									color: "#FAC858"
								},
							},
							{
								value: 1500,
								name: '维修中',
								itemStyle: {
									color: "#EE6666"
								},
							}
						]
					}]
				},


				option2: {
					legend: {
						bottom: '30%',
						left: "20%"
					},
					series: [{
						width: '100%',
						startAngle: 0, // 饼图的角度
						hoverAnimation: false, // 取消饼图放大效果
						name: '访问来源',
						type: 'pie',
						radius: ['30%', '70%'],
						avoidLabelOverlap: true,
						label: {
							show: true,
							position: 'center',
							normal: {
								padding: [0, 2], //文字和图的边距
								rich: {
									formatter: '{b|{b}} {c|{c}}', //图形外文字上下显示
									borderWidth: 30,
									borderRadius: 4,
									a: {
										color: '#333',
										fontSize: 14,
										lineHeight: 30
									},
									b: { //name 文字样式
										fontSize: 14,
										lineHeight: 40,
										color: '#CDCDD0',
									},
									c: { //value 文字样式
										fontSize: 14,
										lineHeight: 40,
										color: '#63BF6A',
										align: "center"
									}
								}
							}

						},
						emphasis: {
							label: {
								show: true,
								fontSize: '18',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: [{
								value: 100,
								itemStyle: {
									normal: {
										color: "transparent" // 透明色
									}
								},
								name: ''
							},
							{
								value: 40.1,
								name: '7/1：40.1%',
								itemStyle: {
									color: "rgb(0,102,80)"
								},
							},
							{
								value: 30,
								name: '7/2：30%',
								itemStyle: {
									color: "#73c0de"
								},
							},
							{
								value: 20,
								name: '7/3：20%',
								itemStyle: {
									color: "#ea7ccc"
								},
							},
							{
								value: 10,
								name: '7/3：10%',
								itemStyle: {
									color: "#5470c6"
								},
							},
						]
					}]
				}

			}
		},
		mounted() {
			
		},
		methods: {},
		watch: {},
		created() {}
	}
</script>
